import { observer } from 'mobx-react';
import { DocumentForms, useDocumentStore } from '@roc/feature-documents';
import { useEffect, useState } from 'react';
import { PDFPreview } from '@roc/ui';
import CopyUrlModal from '../drawRequests/components/copyUrlModal';
import { useDrawsStore } from '../hooks';

interface DrawDocumentFormsProps {
  loanId: number;
  drawId: number;
}

export const DrawDocumentForms = observer(({ loanId, drawId }: DrawDocumentFormsProps) => {
  const { documentStore } = useDocumentStore();
  const { drawStore } = useDrawsStore();
  const [isCopyUrlForPropertyPhotosModalOpen, setIsCopyUrlForPropertyPhotosModalOpen] = useState(false);

  useEffect(() => {
    if (documentStore.openSharePropertyPicturesLinkModal) {
      setIsCopyUrlForPropertyPhotosModalOpen(true);
    }
  }, [documentStore.openSharePropertyPicturesLinkModal]);

  const handleCopyPropertyPhotosUrlModalClose = () => {
    documentStore.openSharePropertyPicturesLinkModal = false;
    setIsCopyUrlForPropertyPhotosModalOpen(false);
  };

  const handleCopyPropertyPhotosUrl = () => {
    navigator.clipboard.writeText(drawStore.propertyPhotosUrl);
    handleCopyPropertyPhotosUrlModalClose();
  };

  return (
    <>
      <DocumentForms loanId={loanId?.toString()} />
      <PDFPreview
        open={documentStore.documentPreview != null}
        title={documentStore.documentPreview?.title}
        data={documentStore.documentPreview?.data}
        dataV2={documentStore.documentPreview?.data}
        headers={documentStore.documentPreview?.headers}
        onClose={() => documentStore.closeDocumentPreview()}
      />
      <CopyUrlModal
        handleClose={handleCopyPropertyPhotosUrlModalClose}
        handleCopy={handleCopyPropertyPhotosUrl}
        isOpen={isCopyUrlForPropertyPhotosModalOpen}
        url={drawStore.propertyPhotosUrl}
      />
    </>
  );
});
